import { render, staticRenderFns } from "./ClcReportAntiquity.vue?vue&type=template&id=3c35c100&"
import script from "./ClcReportAntiquity.vue?vue&type=script&lang=js&"
export * from "./ClcReportAntiquity.vue?vue&type=script&lang=js&"
import style0 from "./ClcReportAntiquity.vue?vue&type=style&index=0&id=3c35c100&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports